import React from "react";

export default function Blog() {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-4">Blog</h1>
      <p className="mb-6 text-gray-400">
        I regularly share thoughts and deep dives on marketing technology, automation, and analytics on <strong>Note</strong>, a Japanese blogging platform.
      </p>
      <a href="https://note.com/meg_martech" target="_blank" rel="noreferrer" className="inline-block bg-sky-500 hover:bg-sky-600 text-white font-bold py-2 px-4 rounded-full transition">
        Read My Blog on Note
      </a>
      <div className="mt-6">
        <a href="/" className="text-gray-400 hover:underline">← Back to Home</a>
      </div>
    </div>
  );
}
